const huTranslations = {
  // Navbar
  'about': 'Rólunk',
  'solutions': 'Megoldások',
  'contact': 'Kapcsolat',
  
  // Hero Section
  'hero_title': 'Innovatív technológia a fenntartható jövőért',
  'hero_subtitle1': 'Csapatunk szenvedélyesen hisz abban, hogy a megújuló energia kulcsfontosságú bolygónk jövője szempontjából. Fejlett megoldásunk egyesíti a legújabb technológiákat, hogy maximalizálja napelemes rendszere teljesítményét és megtérülését.',
  'hero_subtitle2': 'Az energiafogyasztás optimalizálásával nemcsak költségeket takarít meg, hanem jelentősen hozzájárul a szén-dioxid-kibocsátás csökkentéséhez és egy tisztább, zöldebb jövő megteremtéséhez.',
  'hero_cta_arbitrinity': 'Ismerje meg az Arbitrinity megoldást',
  'hero_cta_contact': 'Kapcsolat',

  // Market Situation
  'market_situation_title': 'Piaci helyzet',
  'market_situation_text1': 'Az energiapiacot érintő kihívások egyre összetettebbé válnak, hiszen a makrogazdasági és energiabiztonsági tényezők mellett a szigorodó európai klímapolitika is egyre nagyobb nyomást helyez a szereplőkre. Az innovációs versenyben való globális lemaradás kockázata, valamint az infláció okozta gazdasági nyomás tovább súlyosbítja a helyzetet.',
  'market_situation_text2': 'Az árampiacot különösen érzékenyen érintik a napközbeni és éves termelési egyenlőtlenségek, amelyek jelentős árkilengéseket okoznak. Bár a megújuló energiaforrások aránya folyamatosan nő, az energiahálózat infrastruktúrája nehezen birkózik meg az integrációs kihívásokkal, ami ellátásbiztonsági és gazdasági problémákat eredményez.',
  'market_situation_text3': 'Az áramfogyasztók és kereskedők számára a megújuló energiaforrások kihasználatlansága is komoly veszteséget jelent. Az ipari felhasználók esetében a megtermelt zöldenergia akár 40%-a is kárba veszhet, mivel a fogyasztás és termelés összehangolásához szükséges eszközök és megoldások korlátozottak. Tovább növekednek az energiaellátás költségei és kiszámíthatatlansága, miközben a fenntartható és gazdaságos működés iránti igény egyre sürgetőbbé válik.',

  // Solution Section
  'solution_title': 'A megoldás',
  'solution_subtitle': 'Integratív platform, ami az összes érintett szereplőt összefogja.',
  'solution_point1': '1.) Segíti a tisztán napelemre épülő saját célra termelő erőművek fogyasztását és termelését.',
  'solution_point2': '2.) Képesek rendszerszintű, a szabályozó által elvárt tartalék szolgáltatásra.',
  'solution_point3': '3.) Rugalmasságot és több szolgáltatási lehetőséget biztosít az aggregátorok és energiakereskedők számára.',

  'solution_card1_title': 'Intelligens energia menedzsment',
  'solution_card1_desc': 'Automatizált rendszer, amely optimalizálja az energiaáramlást a napelemek, az akkumulátorok és a hálózat között.',
  'solution_card2_title': 'Adatalapú',
  'solution_card2_desc': 'Valós időben dolgozzuk fel az összes rendelkezésre álló adatot, amit egy tanuló algoritmus segítségével optimalizálunk.',
  'solution_card3_title': 'Rendszerszintű',
  'solution_card3_desc': 'A villamosenergia összetett és nagyon sok szereplős, ezért a megoldásunk is rendszerszemléletű.',
  'solution_card4_title': 'Egyszerű hardverigény',
  'solution_card4_desc': 'Nem kell sok új eszköz beépíteni, üzemeltetni ahhoz, hogy működjön a platform, egyetlen eszköz kell, amit biztosítunk.',
  'solution_card5_title': 'Könnyű kezelés',
  'solution_card5_desc': 'Szerződéskötés után minimális feladat van a platformmal, könnyen kezelhető felületen lehet nyomonkövetni az elért eredményeket.',
  'solution_card6_title': 'Támogatás',
  'solution_card6_desc': 'Szakértőink rendelkezésre állnak és segítenek az optimális rendszer kihasználtság elérésben.',
  'solution_card7_title': 'Valós idejű teljesítmény monitorozás',
  'solution_card7_desc': 'Kövesse nyomon napelem rendszere teljesítményét és energiatermelését valós időben, bárhol és bármikor.',
  'solution_card8_title': 'Biztonságos működés',
  'solution_card8_desc': 'Fejlett biztonsági protokollok, amelyek védik rendszerét és adatait a külső beavatkozásoktól.',

  // Features Section
  'features_title': 'Főbb jellemzők',
  'features_list1': 'Egy átlagos fogyasztó energiatárolási beruházásának megtérülési idejét felezzük.',
  'features_list2': 'Segítünk a legtöbbet kihozni a megújuló rendszerből, nincs kárbaveszett energia (Visszwattos rendszerek).',
  'features_list3': 'Kontrollt viszünk a változó külső tényezők kihívásaival szemben.',
  'features_list4': 'Menetrendezési szolgáltatásunkkal csökkentjük az energiakereskedő kockázatát.',
  'features_list5': 'Nagyobb stabilitást viszünk a villamosenergia piac működésébe.',
  'features_list6': 'Versenyképesebbé tesszük a vállalkozásokat.',

  // Actors Section
  'actors_title': 'Szereplők',
  'actors_card1_title': 'Ügyfél (vállalkozás)',
  'actors_card1_desc': 'Optimalizáljuk a működését, energiatárolási beruházásának megtérülési idejét felezzük.',
  'actors_card2_title': 'Energiakereskedő',
  'actors_card2_desc': 'Villamos-energia árának változásának a kockázat minimálisra csökkentjük.',
  'actors_card3_title': 'BlueTech Energy Solution',
  'actors_card3_desc': 'Adatok alapján optimalizálja az ügyfél működését.',
  'actors_card4_title': 'Aggregátor',
  'actors_card4_desc': 'Adatszolgáltatás a várható működésről.',

  // Awards Section
  'awards_title': 'Elismerések',
  'awards_description': 'Elődöntőbe jutottunk az Amsterdam Science & Innovation Award 2025-ön',
  'awards_details': '(eredmény 2025.06.17.)',
  'awards_read_more': 'Bővebben itt',

  // About Section
  'about_title': 'Rólunk',
  'about_text1': 'A Blue Tech azzal a küldetéssel alakult, hogy innovatív megoldásokat kínáljon az energiaszektorban.',
  'about_text2': 'Büszkék vagyunk arra, hogy úttörő szerepet játszunk az energiahatékonyság és optimalizálás területén. Az Arbitrinity rendszerünk a legújabb technológiát képviseli portfóliónkban, amely forradalmasítja a napelemes rendszerek teljesítményét és megtérülését.',
  'about_text3': 'Célunk, hogy segítsük ügyfeleinket energiafogyasztásuk optimalizálásában, költségeik csökkentésében és energiarendszereiket jövőállóvá és ellenállóvá tenni, miközben jelentősen hozzájárultunk a szén-dioxid-kibocsátás mérsékléséhez és a villamosenergia-piac stabilabb működéséhez.',

  // Values Section
  'values_title': 'Alapértékeink',
  'values_card1_title': 'Innováció',
  'values_card1_desc': 'Folyamatosan fejlesztjük megoldásainkat, hogy élenjárók maradjunk a technológia világában és a legjobb eredményeket biztosítsuk ügyfeleinknek.',
  'values_card2_title': 'Fenntarthatóság',
  'values_card2_desc': 'Minden döntésünket és fejlesztésünket a környezeti fenntarthatóság és a jövő generációk iránti felelősség vezérli.',
  'values_card3_title': 'Partnerség',
  'values_card3_desc': 'Ügyfeleinkkel és partnereinkkel szoros együttműködésben dolgozunk, hogy közösen érjük el a legjobb eredményeket és építsük a fenntartható jövőt.',

  // CTA Section
  'cta_title': 'Készen áll a hatékonyabb energiagazdálkodásra?',
  'cta_subtitle': 'Ismerje meg az Arbitrinity megoldásunkat, amely maximalizálja napelemes rendszere teljesítményét és megtérülését.',
  'cta_button': 'Fedezze fel az Arbitrinity-t',

  // Contact Section
  'contact_title': 'Kapcsolat',
  'contact_subtitle': 'Legyen az első, aki értesül a megoldásunkról.',
  'contact_message_placeholder': 'Írjon a cégről, napelemes rendszerről, akkumulátorról (ha van) stb.',

  // Basic Contact Form
  'contact_basic_subtitle': 'Kérdése van? Szívesen segítünk! Töltse ki az alábbi űrlapot, és szakértő kollégánk hamarosan felveszi Önnel a kapcsolatot, vagy írj az',
  'contact_basic_email_link': 'info@btes.hu',
  'contact_basic_email_suffix': 'e-mail címre.',
  'contact_basic_name': 'Név',
  'contact_basic_email': 'E-mail cím',
  'contact_basic_message': 'Üzenet',
  'contact_basic_privacy': 'A form kitöltésével elfogadja az Adatkezelési tájékoztatót. Az adatait kizárólag a kapcsolatfelvétel céljából használjuk fel.',
  'contact_basic_send': 'Üzenet küldése',
  'contact_basic_sending': 'Küldés...',

  // Footer
  'footer_description': 'Innovatív megoldások a megújuló energia optimális felhasználására.',
  'copyright': '© {year} BlueTech. Minden jog fenntartva.',
  'privacy_policy_link': 'Adatkezelési tájékoztató',
  'privacy_policy': 'Adatkezelési tájékoztató',

  // Contact Form Business Types
  'contact_business_type': 'Vállalkozás típusa',
  'business_type_default': 'Válasszon vállalkozás típust',
  'business_type_small': 'Kis vállalkozás',
  'business_type_medium': 'Közepes vállalkozás',
  'business_type_large': 'Nagy vállalkozás',
  'business_type_sole': 'Egyéni vállalkozás',
  
  // Add the new translation for design services
  'contact_design_services': 'Tervezési szolgáltatás is érdekel?',
  'contact_processing': 'Feldolgozás...',

  // Update Arbitrinity Hero Section
  'arbitrinity_hero_title': 'Küldetésünk: Segíteni az árampiaci kereskedőknek, kis és nagy fogyasztóknak, hogy a legtöbbet hozhassák ki a megtermelt megújuló energiából.',
  'arbitrinity_hero_cta1': 'A megoldás',
  'arbitrinity_hero_cta2': 'Kapcsolat',

  // Contact Form Fields (updating/adding missing translations)
  'contact_person': 'Kapcsolattartó neve',
  'contact_email': 'E-mail cím',
  'contact_phone': 'Telefonszám',
  'contact_message': 'Üzenet',
  'contact_company': 'Cég neve',
  'contact_button': 'Küldés',
  
  // EMS Calculator Page
  'ems_nav': 'EMS Kalkulátor',
  'ems_hero_title': 'EMS - A jövőbiztos erőművek alapja',
  'ems_hero_subtitle': 'A modern energiarendszerek alapja a megbízható vezérlés és a valós idejű adat, amely biztosítja a stabil működést, a költséghatékonyságot és a maximális termelési teljesítményt. Megoldásaink segítenek abban, hogy napelemes és energiatárolós beruházásai valóban megtérüljenek.',
  
  'ems_calculator_title': 'Kalkulátor',
  'ems_calculator_subtitle': 'Célunk, hogy projektszintű becslést adjunk, amely lehetővé teszi partnereink számára:',
  'ems_calculator_point1': 'néhány alapadat alapján előzetes árbecslést kapjanak EMS rendszereinkre,',
  'ems_calculator_point2': 'áttekintsék, milyen modulokkal egészíthető ki a rendszer,',
  'ems_calculator_point3': 'és könnyebben megtervezzék beruházásuk műszaki és költségszerkezetét.',
  
  'ems_hardware_title': 'EMS hardver és szoftver',
  'ems_hardware_subtitle': 'Az általunk kínált EMS hardver és vezérlő rendszer biztosítja:',
  'ems_hardware_point1': 'a megbízható, stabil és optimalizált erőművi működést,',
  'ems_hardware_point2': 'a megújuló energiatermelés és energiatárolás összehangolt irányítását,',
  'ems_hardware_point3': 'a hálózati előírások és üzemeltetési követelmények folyamatos teljesítését,',
  'ems_hardware_point4': 'és a teljes energiafolyamat átlátható, valós idejű monitorozását.',
  
  'ems_why_title': 'Miért velünk?',
  'ems_why_point1': '10+ év tapasztalat erőművezérlés és energiarendszerek tervezése terén',
  'ems_why_point2': 'Mély integráció: PV + BESS + EMS egységes rendszerben',
  'ems_why_point3': 'Moduláris, testre szabható megoldások',
  'ems_why_point4': 'Maximális üzembiztonság és optimalizáció',
  'ems_why_point5': 'A teljes folyamatot lefedjük a tervezéstől az üzemeltetésig',
  
  'ems_pricing_title': 'Mit tartalmaz az indikatív ár?',
  'ems_pricing_hardware': 'Hardver',
  'ems_pricing_software': 'Szoftver - 5 évre',
  'ems_pricing_config': 'Konfigurációs díj',
  'ems_pricing_installation': 'Helyszíni beüzemelés díja (igény esetén)',
  
  'ems_cta_text': 'Célunk, hogy ügyfeleink a lehető legmagasabb hatékonyságot, megtérülést és üzembiztonságot érjék el energiarendszereikkel.',
  'ems_cta_contact': 'Vegye fel velünk a kapcsolatot, és segítünk megtervezni a legjobb műszaki és gazdasági megoldást.',
  'ems_cta_button': 'Kalkuláció',
  
  'ems_form_title': 'Kalkuláció',
  'ems_form_subtitle': 'Töltse ki az űrlapot és tekintse meg az indikatív ajánlatunkat.',
  'ems_form_project_name': 'Projekt neve',
  'ems_form_pv_power': 'PV inverter(ek) AC teljesítménye (kW)',
  'ems_form_battery_power': 'Akkumulátoros inverter(ek) AC teljesítménye (kW)',
  'ems_form_onsite': 'Helyszíni beüzemelés',
  'ems_form_submit': 'Kalkuláció kérése',
  'ems_form_success': 'Köszönjük! Hamarosan felvesszük Önnel a kapcsolatot.',
  'ems_form_error': 'Hiba történt az űrlap elküldése során. Kérjük, próbálja újra.',
  
  // EMS Calculator Results
  'ems_result_title': 'Indikatív ajánlat',
  'ems_result_price_label': 'Becsült ár:',
  'ems_result_description': 'Ez egy előzetes kalkuláció a megadott adatok alapján. Pontos árajánlatért vegye fel velünk a kapcsolatot.',
  'ems_result_email_label': 'E-mail cím a későbbi kapcsolattartáshoz',
  'ems_result_email_required': 'Kérjük, adja meg e-mail címét a PDF letöltéséhez',
  'ems_result_pdf_button': 'Ajánlat letöltése PDF-ben',
  'ems_result_new_calculation': 'Új kalkuláció',
};

export default huTranslations;
